<template>
    <div class="page egiftPage" v-if="giftTypeList">
        <div class="descktopMediaBox">
            <div class="h1 text-center mb-5">
                Send a gift card
            </div>
        </div>
        <form @submit.prevent="nextStage">
            <div class="container">
                <div class="selectGiftCard">
                    <div class="title h1">
                        Select a gift card
                    </div>
                    <div class="giftTypeList" v-if="giftTypeList">
                        <template
                            v-if="gtype.allow_online_purchase" v-for="(gtype,index) in giftTypeList"
                        >
                            <div class="el"
                                 v-for="(img,ix) in gtype.images"
                                 @click="selectCardType(gtype.id,ix,img.image_2x)"
                                 :class="{ active: (gtype.id + '_' + ix) === (gcard.type_id + '_' + gcard.theme_index) }"
                            >
                                <img :src="img.image_2x">
                            </div>
                        </template>
                    </div>
                </div>
                
                <div class="flexWrap">
                    <div class="mainFrame">
                        <img v-if="gcard.imgDef" :src="gcard.imgDef" alt="">
                        <img v-if="!gcard.imgDef" :src="getStaticImage('icons/giftcards/giftDef.png')">
                    </div>
                    <div class="righySide">
                        <div class="personalMessage">
                            <div class="title h2">
                                Personal Message
                            </div>
                            <textarea maxlength="150" v-model="gcard.description" placeholder="Send a short and sweet message!"></textarea>
                            <span class="caption">{{gcard.description.length}}/150</span>
                        </div>
                        <div class="datePickerSection">
                            <div class="h2">Delivery Date</div>
                            <div class="formRow">
                                <md-datepicker v-model="delivery_date" md-immediately required :md-disabled-dates="disabledDates" @md-opened="$refs.mkDatePicker.$el.querySelector('input').blur()" ref="mkDatePicker"/>
                            </div>
                        </div>
                        <GiftCardAmount :gcard="gcard"/>
                    </div>
                </div>
    
                <div class="flexWrap thisFor">
                    <div class="h2 descktopMediaBox">Who’s this for?</div>
                    <div class="theirInfo">
                        <div class="h3 title colorBlack">
                            Their Info
                        </div>
                        <div class="formRow">
                            <input type="text" name="fnameR" placeholder="Recipient’s First Name" v-model="gcard.recipient_fname" required>
                        </div>
                        <div class="formRow">
                            <input type="text" name="lnameR" placeholder="Recipient’s Last Name" v-model="gcard.recipient_lname" required>
                        </div>
                        <div class="formRow">
                            <input type="email" name="emailR" placeholder="Recipient’s Email" v-model="gcard.recipient_email" required>
                        </div>
                    </div>
                    <div class="yourInfo">
                        <div class="h3 title colorBlack">
                            Your Info
                        </div>
                        <div class="formRow">
                            <input type="text" name="fnameY" placeholder="Your First Name" v-model="gcard.purchaser_fname" required>
                        </div>
                        <div class="formRow">
                            <input type="text" name="lnameY" placeholder="Your Last Name" v-model="gcard.purchaser_lname" required>
                        </div>
                        <div class="formRow">
                            <input type="email" name="emailY" placeholder="Your Email" v-model="gcard.purchaser_email" required>
                        </div>
                    </div>
                </div>
                <div class="bntBox">
                    <button class="smlBtn zbg">
                        Continue
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import moment from "moment";
    import GiftcardsList from "../../components/checkout/GiftCardsList";
    import GiftCardAmount from "../../components/checkout/GiftCardAmount";

    export default {
        name: 'Egifts',
        components: {GiftCardAmount, GiftcardsList},
        data() {
            return {
                delivery_date: new Date(),
                gcard: {
                    type_id: null,
                    description: "",
                    recipient_email: null,
                    recipient_name: null,
                    recipient_fname: null,
                    recipient_lname: null,
                    purchaser_email: null,
                    purchaser_name: null,
                    purchaser_lname: null,
                    purchaser_fname: null,
                    amount: '25',
                    custom_ammount: 0,
                    theme_index: null
                },
                giftTypeList: null
            }
        },
        created() {
            if(this.giftCardData.my_wallet === true){
                this.$store.commit("giftcard/resetGcart");
                this.giftCardData.my_wallet = false;
            }
            this.$store.commit("shared/setTopBar", {title: "Send an E-Gift", showBackButton: false, showBag: false}, {root: true});
            this.$store.dispatch("giftcard/getGiftCardsList", {
                callback: (res) => {
                    if (res.data) {
                        this.giftTypeList = res.data;
                        this.giftTypeList?.map(m => {
                            if (m.allow_online_purchase) {
                                m.images.map(img => {
                                    this.selectCardType(m.id, 0, img.image_2x);
                                    return false;
                                });
                                return false;
                            }
                        });
                    }
                }
            });
            if (typeof this.$route.query.cartItem !== "undefined") {
                this.gcard = this.giftCardData.cards[this.$route.query.cartItem];
                if (!this.giftCardData.cards[this.$route.query.cartItem]){
                    return this.$router.push({name: "Home"});
                    return false;
                }
                this.delivery_date = this.gcard.delivery_date_object.toDate();
                if (this.gcard.amount != 10 && this.gcard.amount != 25 && this.gcard.amount != 50 && this.gcard.amount != 100) {
                    this.gcard.amount = 'custom';
                }
            } else {
                if (this.user) {
                    this.gcard.purchaser_fname = this.user.first_name;
                    this.gcard.purchaser_lname = this.user.last_name;
                    this.gcard.purchaser_email = this.user.email;
                }
            }
        },
        methods: {
            nextStage() {
                if (!this.gcard.type_id) {
                    this.$store.commit("shared/setAlert", "Please select a gift card");
                    return false;
                }

                if (!this.delivery_date) {
                    this.$store.commit("shared/setAlert", "Please select a gift card deliver date");
                    return false;
                }

                this.gcard.delivery_date_object = moment(this.delivery_date);
                this.gcard.delivery_date = this.gcard.delivery_date_object.format("YYYY-MM-DD");
                
                if (this.gcard.amount == 'custom') {
                    this.gcard.amount = this.gcard.custom_ammount;
                }
                if (this.gcard.amount == 0) {
                    this.$store.commit("shared/setAlert", "Please select a gift card amount");
                    return false;
                }

                this.gcard.purchaser_name = this.gcard.purchaser_fname + " " + this.gcard.purchaser_lname;
                this.gcard.recipient_name = this.gcard.recipient_fname + " " + this.gcard.recipient_lname;

                if (typeof this.$route.query.cartItem !== "undefined") {
                    this.$store.commit("giftcard/updateGiftCard", {index: this.$route.query.cartItem, item: this.gcard});
                } else {
                    this.$store.commit("giftcard/addGiftCard", this.gcard);
                }
                this.$router.push({name: "EgiftList"});
                return false;
            },
            selectCardType(type_id, theme_id, img_def) {
                this.gcard.theme_index = theme_id;
                this.gcard.type_id = type_id;
                this.gcard.imgDef = img_def;
            },
            disabledDates(date) {
                return new Date(new Date().setDate(new Date().getDate()-1)) > date;
            }
            
        },
        computed: {
            giftCardData() {
                return this.$store.state.giftcard.giftCardData
            }
        }
    }
</script>
